import React, { useState } from "react";
import {
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import ShareStockLogo from "../Pictures/ShareStockLogo";
import { Facebook, Instagram, LinkedIn } from "@mui/icons-material";
import TermsAndConditionsModal from "../Modals/TermsAndConditionsModal";

const ShareStockFooter: React.FC = () => {
    const [termsAndConditionsModalOpen, setTermsAndConditionsModalOpen] = useState<boolean>(false);


  return (
    <Container maxWidth={false} id='FooterContainer' sx={{mt: 6, pb: 18, justifyContent: "center", justifyItems: "center", display: "flex"}} disableGutters>
      <Divider sx={{ borderBottomWidth: 100, borderBottomColor: "#0057B2" }}/>
        <Container sx={{justifyContent: "center", justifyItems: "center", display: "flex"}}>

            <Grid container direction={"column"}  maxWidth={'sm'} justifyContent={"center"} justifyItems={"center"}>
                <Grid item xs={2}>
                    <ShareStockLogo size={140} />
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="h3">
                        ShareStock
                    </Typography>
                    <Typography variant="overline">
                        1000+ Boutiques. 200 Brands. 0 Wasted Inventory.
                    </Typography>
                    <Typography variant="subtitle2">
                        Supporting Boutiques across America.
                    </Typography>
                </Grid>
                <Grid item sx={{mt: 2, mb: 0}}>
                    <Grid container direction={"row"} justifyContent={"center"} justifyItems={"center"}>
                        <Grid item xs={4}>
                             <Typography variant="h5" gutterBottom>
                                Support
                            </Typography>
                            {/*<Typography variant="body1" gutterBottom>
                                Initiate Return                            
                            </Typography> */}
                            <Typography variant="body1" gutterBottom>
                                <Link href="/contact" color={"black"} underline="hover">
                                    Contact
                                </Link>
                            </Typography>
                            {/* <Typography variant="body1" gutterBottom>
                                Shipping                         
                            </Typography> */}
                            <Typography variant="body1" gutterBottom>
                                FAQ                         
                            </Typography>
                        </Grid>
                         <Grid item xs={4}>
                            <Typography variant="h5" gutterBottom>
                                About
                            </Typography>
                            {/* <Typography variant="body1" gutterBottom>
                                About Us                            
                            </Typography> */}
                            {/* <Typography variant="body1" gutterBottom>
                                Reviews                         
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                Careers                         
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                Boutique Sign Up                         
                            </Typography> */}
                            <Typography
                                onClick={() => setTermsAndConditionsModalOpen(true)}
                                variant="body1"
                                gutterBottom
                                sx={{
                                    color: "black", // Link color (based on theme)
                                    textDecoration: "underline", // Underline the text
                                    cursor: "pointer", // Pointer cursor for clickable effect
                                }}
                            >
                                Terms & Conditions
                            </Typography>

                            {/* <Typography variant="body1" gutterBottom>
                                Affiliates                       
                            </Typography> */}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction={"row"} justifyContent={"center"} justifyItems={"center"}>
                        {/* https://www.facebook.com/profile.php?id=61572439130758&sk=about */}
                        <IconButton>
                            <Facebook />
                        </IconButton>
                        <IconButton>
                            <LinkedIn />
                        </IconButton>
                        <IconButton>
                            <Instagram />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
        <TermsAndConditionsModal open={termsAndConditionsModalOpen} onClose={() => setTermsAndConditionsModalOpen(false)} />
      
    </Container>
  );
};

export default ShareStockFooter;
